/* =====================================================================
   JBOXLY · Correos desde el CRM (v1.1 · 3-oct-2026: título grande, viñetas, recuadros)
   Archivo: assets/jbx-crm-correo.js  (Shopify, tema "Copia de Impulse")
   Se carga en sections/bandeja-wa.liquid con una línea ENCIMA de {% schema %}.

   Qué hace:
   - En la ficha del cliente (Embudo, Mi día, Clientes o el chat) agrega el botón
     "📧 Enviar correo" si el cliente tiene email.
   - En "⋯ Acciones" del chat agrega "📧 Enviar correo": abre la ficha de ese
     cliente y luego la ventana del correo.
   - Ventana: elegir plantilla, editar asunto / texto / botón, ver la vista previa
     real (con los datos del cliente), enviar. El tope diario se ve arriba.
   - Dueño y administradores: guardar cambios en una plantilla, guardar una
     nueva o borrarla (para todo el equipo).

   Todo pasa por /api/wa-admin con la sesión de la bandeja (bwa_token).
   Ninguna clave va en este archivo.
   ===================================================================== */
(function (w, d) {
  'use strict';
  if (w.JBXCrmCorreo) return;

  var API = 'https://jboxly-realtime-search.vercel.app/api/wa-admin';
  var RE_EMAIL = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
  var RE_PEDIDO = /^(PED|PAQ)-\d{6}-\d{4}$/;
  var RE_RELLENAR = /\(escribe aqu[ií][^)]*\)/i;

  var CSS = [
    '.jcm-fondo{position:fixed;inset:0;background:rgba(5,6,8,.72);z-index:100005;display:flex;align-items:flex-start;justify-content:center;overflow-y:auto;padding:24px 14px;box-sizing:border-box;font-family:Inter,system-ui,-apple-system,"Segoe UI",Arial,sans-serif;}',
    '.jcm-caja [hidden]{display:none !important;}',
    '.jcm-caja{background:#16161c;color:#e9e9ee;border:1px solid #2c2c36;border-radius:14px;width:100%;max-width:980px;padding:18px 20px 18px;box-shadow:0 30px 60px -20px rgba(0,0,0,.6);box-sizing:border-box;}',
    '.jcm-cab{display:flex;justify-content:space-between;align-items:flex-start;gap:10px;margin-bottom:12px;}',
    '.jcm-tit{font-size:17px;font-weight:800;margin:0;color:#fff;overflow-wrap:anywhere;}',
    '.jcm-sub{font-size:12.5px;color:#a6a6b2;margin:3px 0 0;line-height:1.45;overflow-wrap:anywhere;}',
    '.jcm-sub b{color:#fff;}',
    '.jcm-cupo{display:inline-block;font-size:11.5px;font-weight:700;border-radius:20px;padding:2px 9px;margin-left:6px;background:#24242c;color:#c9c9d1;white-space:nowrap;}',
    '.jcm-cupo.jcm-poco{background:rgba(239,68,68,.15);color:#fca5a5;}',
    '.jcm-x{background:none;border:none;color:#9a9aa5;font-size:22px;line-height:1;cursor:pointer;padding:4px 6px;border-radius:6px;flex-shrink:0;}',
    '.jcm-x:hover,.jcm-x:focus-visible{color:#fff;background:#24242c;outline:none;}',
    '.jcm-grid{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:16px;}',
    '.jcm-col{min-width:0;display:flex;flex-direction:column;gap:10px;}',
    '.jcm-campo label{display:block;font-size:11px;font-weight:700;letter-spacing:.03em;text-transform:uppercase;color:#a6a6b2;margin:0 0 5px;}',
    '.jcm-campo input,.jcm-campo select,.jcm-campo textarea{width:100%;box-sizing:border-box;background:#0d0d12;border:1px solid #2c2c36;border-radius:9px;color:#f1f1f5;font-size:14px;padding:9px 11px;font-family:inherit;outline:none;-webkit-text-fill-color:#f1f1f5;}',
    '.jcm-campo textarea{min-height:190px;resize:vertical;line-height:1.5;}',
    '.jcm-campo select{background:#fff;color:#1c1c22;-webkit-text-fill-color:#1c1c22;}',
    '.jcm-campo input:focus,.jcm-campo select:focus,.jcm-campo textarea:focus{border-color:#fe7905;box-shadow:0 0 0 3px rgba(254,121,5,.18);}',
    '.jcm-dos{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1.4fr);gap:10px;}',
    '.jcm-ayuda{font-size:11.5px;color:#8a8a94;line-height:1.5;margin:0;}',
    '.jcm-ayuda b{color:#d7d7de;}',
    '.jcm-vars{display:flex;flex-wrap:wrap;gap:5px;}',
    '.jcm-var{background:#0d0d12;border:1px solid #3a2a1a;color:#fdba74;border-radius:20px;font:600 11.5px "IBM Plex Mono",ui-monospace,Menlo,monospace;padding:4px 9px;cursor:pointer;}',
    '.jcm-var:hover,.jcm-var:focus-visible{border-color:#fe7905;color:#fff;outline:none;}',
    '.jcm-gest{display:flex;flex-wrap:wrap;gap:6px;}',
    '.jcm-gest button{background:#0d0d12;color:#c9c9d1;border:1px solid #2c2c36;border-radius:8px;padding:7px 10px;font:600 12px inherit;font-family:inherit;cursor:pointer;}',
    '.jcm-gest button:hover,.jcm-gest button:focus-visible{border-color:#fe7905;color:#fff;outline:none;}',
    '.jcm-gest .jcm-borrar:hover{border-color:#ef4444;color:#fca5a5;}',
    '.jcm-prev-cab{font-size:12px;color:#a6a6b2;background:#0d0d12;border:1px solid #2c2c36;border-bottom:none;border-radius:10px 10px 0 0;padding:8px 11px;overflow-wrap:anywhere;}',
    '.jcm-prev-cab b{color:#fff;}',
    '.jcm-prev{width:100%;height:640px;border:1px solid #2c2c36;border-radius:0 0 10px 10px;background:#f4f4f6;display:block;}',
    '.jcm-prev-vacio{display:flex;align-items:center;justify-content:center;text-align:center;height:640px;border:1px dashed #2c2c36;border-radius:10px;color:#8a8a94;font-size:13px;padding:20px;box-sizing:border-box;}',
    '.jcm-msg{border-radius:9px;padding:9px 12px;font-size:12.5px;line-height:1.5;}',
    '.jcm-msg.err{background:rgba(239,68,68,.12);border:1px solid rgba(239,68,68,.45);color:#fca5a5;}',
    '.jcm-msg.ok{background:rgba(34,197,94,.10);border:1px solid rgba(34,197,94,.45);color:#bbf7d0;}',
    '.jcm-msg.info{background:rgba(254,121,5,.10);border:1px solid rgba(254,121,5,.40);color:#fed7aa;}',
    '.jcm-msg b{color:#fff;}',
    '.jcm-pie{display:flex;gap:10px;margin-top:14px;}',
    '.jcm-pie button{flex:1;border:none;border-radius:10px;padding:12px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit;}',
    '.jcm-no{background:#0d0d12;color:#b4b4be;border:1px solid #2c2c36 !important;}',
    '.jcm-si{background:#fe7905;color:#fff;}',
    '.jcm-si:hover{background:#ff8a24;}',
    '.jcm-pie button:disabled{opacity:.5;cursor:not-allowed;}',
    '.jcm-pie button:focus-visible{outline:2px solid #fff;outline-offset:2px;}',
    '@media (max-width:760px){.jcm-grid{grid-template-columns:1fr;}.jcm-prev,.jcm-prev-vacio{height:520px;}.jcm-caja{padding:14px;}.jcm-fondo{padding:10px 8px;}.jcm-dos{grid-template-columns:1fr;}}'
  ].join('\n');

  function estilos() {
    if (d.getElementById('jcm-css')) return;
    var s = d.createElement('style');
    s.id = 'jcm-css';
    s.textContent = CSS;
    d.head.appendChild(s);
  }
  function el(tag, attrs, hijos) {
    var e = d.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      var v = attrs[k];
      if (v === null || v === undefined) return;
      if (k === 'texto') e.textContent = v;
      else if (k === 'clase') e.className = v;
      else if (k.indexOf('on') === 0) e.addEventListener(k.slice(2), v);
      else e.setAttribute(k, v);
    });
    (hijos || []).forEach(function (h) { if (h) e.appendChild(typeof h === 'string' ? d.createTextNode(h) : h); });
    return e;
  }
  function vaciar(e) { while (e.firstChild) e.removeChild(e.firstChild); }
  function token() { try { return sessionStorage.getItem('bwa_token') || ''; } catch (e) { return ''; } }
  function sesionVencida(r) {
    var m = String((r && r.error) || '');
    return (r && r.__status === 401) || m === 'Clave incorrecta' || m.indexOf('Token') === 0 || m.indexOf('Credenciales') === 0;
  }
  function api(cuerpo) {
    cuerpo.token = token();
    return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(cuerpo) })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { j = j || {}; j.__status = r.status; return j; });
      });
  }

  /* plantillas: se piden una vez y se guardan 2 minutos */
  var cache = { t: 0, d: null };
  function cargarPlantillas(fresco) {
    if (!fresco && cache.d && Date.now() - cache.t < 120000) return Promise.resolve(cache.d);
    return api({ accion: 'correo-plantillas' }).then(function (r) {
      if (r && r.ok) { cache.d = r; cache.t = Date.now(); }
      return r;
    });
  }

  var abierto = null;
  function cerrar() {
    if (!abierto) return;
    if (abierto.ocupado) return;
    var a = abierto;
    abierto = null;
    clearTimeout(a.timer);
    d.removeEventListener('keydown', a.tecla, true);
    if (a.fondo.parentNode) a.fondo.parentNode.removeChild(a.fondo);
    if (a.volver && a.volver.focus) { try { a.volver.focus(); } catch (e) {} }
  }

  /* ref: { id, nombre, email, pedidos: [] } */
  function abrir(ref) {
    ref = ref || {};
    estilos();
    abierto && (abierto.ocupado = false);
    cerrar();

    var st = {
      ref: ref, lista: [], editar: false, variables: [], sel: '', editado: false, turno: 0,
      ultimo: null, enviado: false, ocupado: false, timer: 0, foco: null, volver: d.activeElement
    };

    var tit = el('h2', { clase: 'jcm-tit', id: 'jcm-tit', texto: '📧 Correo para ' + (ref.nombre || ref.email || 'el cliente') });
    var cupoEl = el('span', { clase: 'jcm-cupo', hidden: 'hidden' });
    var sub = el('p', { clase: 'jcm-sub' }, ['Para: ', el('b', { texto: ref.email || '…' }), ' · sale de notificaciones@send.jboxly.com y las respuestas llegan a contact@jboxly.com', cupoEl]);
    var x = el('button', { type: 'button', clase: 'jcm-x', 'aria-label': 'Cerrar', texto: '✕', onclick: cerrar });

    /* columna izquierda: el correo */
    var selP = el('select', { id: 'jcm-plantilla' }, [el('option', { value: '', texto: 'Cargando plantillas…' })]);
    var inPed = el('input', { id: 'jcm-pedido', type: 'text', autocomplete: 'off', list: 'jcm-pedidos', placeholder: 'PED-261001-1234', maxlength: '20' });
    var dl = el('datalist', { id: 'jcm-pedidos' });
    (ref.pedidos || []).forEach(function (p) { dl.appendChild(el('option', { value: p })); });
    var campoPed = el('div', { clase: 'jcm-campo', hidden: 'hidden' }, [el('label', { 'for': 'jcm-pedido', texto: 'Pedido' }), inPed, dl,
      el('p', { clase: 'jcm-ayuda', texto: 'Vacío = su último pedido.' })]);
    var inAs = el('input', { id: 'jcm-asunto', type: 'text', maxlength: '150', autocomplete: 'off' });
    var inTi = el('input', { id: 'jcm-titulo', type: 'text', maxlength: '90', autocomplete: 'off', placeholder: 'Ej.: Tus productos te esperan 🛒' });
    var inCu = el('textarea', { id: 'jcm-cuerpo', maxlength: '5000', rows: '9' });
    var inBt = el('input', { id: 'jcm-btn-txt', type: 'text', maxlength: '40', autocomplete: 'off', placeholder: 'Ej.: Ver mi pedido' });
    var inBu = el('input', { id: 'jcm-btn-url', type: 'url', maxlength: '300', autocomplete: 'off', placeholder: 'https://jboxly.com/…' });
    var vars = el('div', { clase: 'jcm-vars', role: 'group', 'aria-label': 'Insertar datos del cliente' });
    var gest = el('div', { clase: 'jcm-gest', hidden: 'hidden' });
    var bGuardar = el('button', { type: 'button', hidden: 'hidden', texto: '💾 Guardar cambios en la plantilla' });
    var bNueva = el('button', { type: 'button', texto: '➕ Guardar como plantilla nueva' });
    var bBorrar = el('button', { type: 'button', clase: 'jcm-borrar', hidden: 'hidden', texto: '🗑️ Borrar plantilla' });
    gest.appendChild(bGuardar); gest.appendChild(bNueva); gest.appendChild(bBorrar);

    var izq = el('div', { clase: 'jcm-col' }, [
      el('div', { clase: 'jcm-dos' }, [
        el('div', { clase: 'jcm-campo' }, [el('label', { 'for': 'jcm-plantilla', texto: 'Plantilla' }), selP]),
        campoPed
      ]),
      el('div', { clase: 'jcm-campo' }, [el('label', { 'for': 'jcm-asunto', texto: 'Asunto' }), inAs]),
      el('div', { clase: 'jcm-campo' }, [el('label', { 'for': 'jcm-titulo', texto: 'Título grande (opcional)' }), inTi]),
      el('div', { clase: 'jcm-campo' }, [el('label', { 'for': 'jcm-cuerpo', texto: 'Texto del correo' }), inCu]),
      el('div', { clase: 'jcm-dos' }, [
        el('div', { clase: 'jcm-campo' }, [el('label', { 'for': 'jcm-btn-txt', texto: 'Botón (opcional)' }), inBt]),
        el('div', { clase: 'jcm-campo' }, [el('label', { 'for': 'jcm-btn-url', texto: 'Enlace del botón' }), inBu])
      ]),
      el('div', null, [
        el('p', { clase: 'jcm-ayuda', texto: 'Toca un dato para ponerlo donde está el cursor:' }),
        vars
      ]),
      el('p', { clase: 'jcm-ayuda' }, [el('b', { texto: '**texto**' }), ' = negrita · una línea que empieza con ', el('b', { texto: '- ' }), ' = viñeta · una línea con solo ',
        el('b', { texto: '{productos}' }), ' = su carrito con fotos y total · una línea con solo ', el('b', { texto: '{casillero}' }), ' o ', el('b', { texto: '{pedido}' }),
        ' = recuadro destacado · el saludo, tu firma y el pie se ponen solos.']),
      gest
    ]);

    /* columna derecha: vista previa */
    var prevCab = el('div', { clase: 'jcm-prev-cab', hidden: 'hidden' });
    var prev = el('iframe', { clase: 'jcm-prev', title: 'Vista previa del correo', sandbox: '', hidden: 'hidden' });
    var prevVacio = el('div', { clase: 'jcm-prev-vacio', texto: 'Elige una plantilla (o escribe el correo) y aquí verás cómo le llega al cliente.' });
    var avisos = el('div', { clase: 'jcm-col', 'aria-live': 'polite' });
    var der = el('div', { clase: 'jcm-col' }, [el('div', null, [prevCab, prev, prevVacio]), avisos]);

    var bNo = el('button', { type: 'button', clase: 'jcm-no', texto: 'Cancelar', onclick: cerrar });
    var bSi = el('button', { type: 'button', clase: 'jcm-si', disabled: 'disabled', texto: '📧 Enviar correo' });

    var caja = el('div', { clase: 'jcm-caja', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'jcm-tit' }, [
      el('div', { clase: 'jcm-cab' }, [el('div', null, [tit, sub]), x]),
      el('div', { clase: 'jcm-grid' }, [izq, der]),
      el('div', { clase: 'jcm-pie' }, [bNo, bSi])
    ]);
    var fondo = el('div', { clase: 'jcm-fondo' }, [caja]);
    fondo.addEventListener('mousedown', function (e) { if (e.target === fondo) cerrar(); });
    d.body.appendChild(fondo);

    st.fondo = fondo;
    st.tecla = function (e) {
      if (!abierto || abierto !== st) return;
      if (e.key === 'Escape') { e.stopPropagation(); e.preventDefault(); cerrar(); return; }
      if (e.key === 'Tab') {
        var f = caja.querySelectorAll('button,input,select,textarea,iframe,[tabindex]');
        var vis = Array.prototype.filter.call(f, function (n) { return !n.disabled && n.offsetParent !== null; });
        if (!vis.length) return;
        var pri = vis[0], ult = vis[vis.length - 1];
        if (e.shiftKey && d.activeElement === pri) { e.preventDefault(); ult.focus(); }
        else if (!e.shiftKey && d.activeElement === ult) { e.preventDefault(); pri.focus(); }
      }
    };
    d.addEventListener('keydown', st.tecla, true);
    abierto = st;
    setTimeout(function () { selP.focus(); }, 30);

    /* ---------- avisos ---------- */
    function aviso(tipo, partes) {
      avisos.appendChild(el('div', { clase: 'jcm-msg ' + tipo }, (Array.isArray(partes) ? partes : [partes])));
    }
    function pintarCupo(c) {
      if (!c) return;
      cupoEl.hidden = false;
      cupoEl.textContent = 'Hoy: ' + c.usados + ' de ' + c.tope;
      cupoEl.title = 'Correos enviados hoy desde el CRM (todo el equipo). Quedan ' + c.quedan + '.';
      cupoEl.className = 'jcm-cupo' + (c.quedan <= 5 ? ' jcm-poco' : '');
      st.cupo = c;
    }

    /* ---------- datos actuales del formulario ---------- */
    function plantillaActual() {
      var p = st.lista.filter(function (q) { return q.id === st.sel; })[0] || {};
      return { id: p.id || '', nombre: p.nombre || '', asunto: inAs.value, titulo: inTi.value.trim(), cuerpo: inCu.value, boton_texto: inBt.value.trim(), boton_url: inBu.value.trim() };
    }
    function usaPedido() { return /\{pedido\}/.test(inAs.value + inTi.value + inCu.value + inBu.value); }
    function pintarGestion() {
      if (!st.editar) return;
      gest.hidden = false;
      var hay = !!st.sel;
      bGuardar.hidden = !(hay && st.editado);
      bBorrar.hidden = !hay;
      bNueva.disabled = !(inAs.value.trim() && inCu.value.trim());
    }

    /* ---------- vista previa ---------- */
    function programar() {
      clearTimeout(st.timer);
      st.timer = setTimeout(preparar, 650);
    }
    function preparar() {
      campoPed.hidden = !usaPedido();
      pintarGestion();
      if (st.enviado) return;
      var pl = plantillaActual();
      if (!pl.asunto.trim() || !pl.cuerpo.trim()) {
        st.ultimo = null;
        bSi.disabled = true;
        prev.hidden = true; prevCab.hidden = true; prevVacio.hidden = false;
        vaciar(avisos);
        return;
      }
      var turno = ++st.turno;
      var cuerpo = { accion: 'correo-preparar', plantilla: pl, pedido: inPed.value.trim().toUpperCase() };
      if (ref.id) cuerpo.id = ref.id; else if (ref.email) cuerpo.email = ref.email;
      bSi.disabled = true;
      api(cuerpo).then(function (r) {
        if (abierto !== st || turno !== st.turno) return;
        vaciar(avisos);
        if (sesionVencida(r)) { aviso('err', 'Tu sesión de la bandeja venció: recarga la página e ingresa de nuevo.'); return; }
        if (!r.ok) { aviso('err', '⚠️ ' + (r.error || 'No se pudo armar la vista previa')); return; }
        st.ultimo = r;
        pintarCupo(r.cupo);
        if (r.cliente && r.cliente.email) { var b = sub.querySelector('b'); if (b) b.textContent = r.cliente.email; }
        if (r.variables && r.variables.pedido && !inPed.value) inPed.placeholder = r.variables.pedido;
        prevCab.hidden = false; prev.hidden = false; prevVacio.hidden = true;
        vaciar(prevCab);
        prevCab.appendChild(d.createTextNode('Asunto: '));
        prevCab.appendChild(el('b', { texto: r.asunto }));
        prev.srcdoc = r.html;
        var bloquea = false;
        if (!r.email_valido) {
          bloquea = true;
          aviso('err', r.cliente && r.cliente.email ? ['El correo de este cliente no sirve para enviar: ', el('b', { texto: r.cliente.email })] : 'Este cliente no tiene correo guardado. Agrégalo primero en su cuenta.');
        }
        if (r.desconocidas && r.desconocidas.length) {
          bloquea = true;
          aviso('err', ['Estos datos no existen y saldrían tal cual: ', el('b', { texto: '{' + r.desconocidas.join('}, {') + '}' }), '. Corrígelos o bórralos.']);
        }
        if (r.faltan && r.faltan.length) {
          var nombres = r.faltan.map(function (k) {
            var v = st.variables.filter(function (q) { return q.k === k; })[0];
            return v ? v.nombre.toLowerCase() : k;
          });
          aviso('info', ['Este cliente no tiene: ', el('b', { texto: nombres.join(', ') }), '. Esa parte queda vacía en el correo; revisa que se lea bien o cambia el texto.']);
        }
        if (RE_RELLENAR.test(inCu.value)) {
          aviso('info', ['Todavía dice ', el('b', { texto: '"' + (inCu.value.match(RE_RELLENAR) || [''])[0] + '"' }), ': cámbialo por el texto real antes de enviar.']);
        }
        if (r.cupo && r.cupo.quedan <= 0) {
          bloquea = true;
          aviso('err', 'Llegaron al tope de hoy (' + r.cupo.tope + ' correos del CRM). Mañana se reinicia.');
        }
        bSi.disabled = bloquea;
      }).catch(function () {
        if (abierto !== st || turno !== st.turno) return;
        vaciar(avisos);
        aviso('err', '⚠️ Sin conexión. Revisa el internet y vuelve a intentar.');
      });
    }

    /* ---------- plantillas ---------- */
    function pintarSelect() {
      vaciar(selP);
      selP.appendChild(el('option', { value: '', texto: st.lista.length ? 'Elige una plantilla…' : 'No hay plantillas' }));
      st.lista.forEach(function (p) { selP.appendChild(el('option', { value: p.id, texto: p.nombre })); });
      selP.appendChild(el('option', { value: '__blanco', texto: '✍️ Correo en blanco' }));
      selP.value = st.sel || '';
    }
    function usarPlantilla(id) {
      if (st.editado && (inAs.value.trim() || inCu.value.trim()) && !w.confirm('Vas a perder lo que escribiste. ¿Cambiar de plantilla?')) {
        selP.value = st.sel || '';
        return;
      }
      if (id === '__blanco') {
        st.sel = '';
        inAs.value = ''; inTi.value = ''; inCu.value = ''; inBt.value = ''; inBu.value = '';
        selP.value = '__blanco';
      } else {
        var p = st.lista.filter(function (q) { return q.id === id; })[0];
        st.sel = p ? p.id : '';
        inAs.value = p ? p.asunto : ''; inTi.value = p ? (p.titulo || '') : ''; inCu.value = p ? p.cuerpo : '';
        inBt.value = p ? p.boton_texto : ''; inBu.value = p ? p.boton_url : '';
      }
      st.editado = false;
      preparar();
    }
    selP.addEventListener('change', function () { usarPlantilla(selP.value); });

    [inAs, inTi, inCu, inBt, inBu, inPed].forEach(function (i) {
      i.addEventListener('input', function () {
        if (i !== inPed) st.editado = true;
        if (st.enviado) return;
        pintarGestion();
        programar();
      });
    });
    [inAs, inTi, inCu, inBt, inBu].forEach(function (i) { i.addEventListener('focus', function () { st.foco = i; }); });

    function insertar(k) {
      var campo = st.foco && st.foco !== inBu ? st.foco : inCu;
      if (campo === inBt) campo = inCu;
      var txt = '{' + k + '}';
      var v = campo.value;
      var a = typeof campo.selectionStart === 'number' ? campo.selectionStart : v.length;
      var b = typeof campo.selectionEnd === 'number' ? campo.selectionEnd : v.length;
      if (k === 'productos') {
        if (campo !== inCu) { campo = inCu; v = campo.value; a = b = v.length; }
        /* la tabla va sola en su línea */
        txt = (a > 0 && v.charAt(a - 1) !== '\n' ? '\n' : '') + txt + (v.charAt(b) !== '\n' ? '\n' : '');
      }
      campo.value = v.slice(0, a) + txt + v.slice(b);
      var pos = a + txt.length;
      campo.focus();
      try { campo.setSelectionRange(pos, pos); } catch (e) {}
      st.editado = true;
      pintarGestion();
      programar();
    }

    function guardarPlantilla(nueva) {
      var pl = plantillaActual();
      if (nueva) {
        var nom = w.prompt('Nombre de la plantilla nueva (lo verá todo el equipo):', pl.nombre ? pl.nombre + ' (copia)' : '');
        if (nom === null) return;
        nom = String(nom).trim();
        if (!nom) { w.alert('Ponle un nombre a la plantilla.'); return; }
        pl.id = ''; pl.nombre = nom;
      } else if (!w.confirm('¿Guardar estos cambios en «' + pl.nombre + '»? Los verá todo el equipo.')) return;
      bGuardar.disabled = bNueva.disabled = bBorrar.disabled = true;
      api({ accion: 'correo-plantilla-guardar', plantilla: pl }).then(function (r) {
        bGuardar.disabled = bNueva.disabled = bBorrar.disabled = false;
        if (abierto !== st) return;
        if (!r.ok) { w.alert('No se guardó: ' + (r.error || '?')); return; }
        st.lista = r.plantillas || st.lista;
        st.sel = r.plantilla ? r.plantilla.id : st.sel;
        st.editado = false;
        cache.d = null;
        pintarSelect();
        pintarGestion();
        aviso('ok', ['✅ Plantilla guardada: ', el('b', { texto: (r.plantilla && r.plantilla.nombre) || pl.nombre })]);
      }).catch(function () { bGuardar.disabled = bNueva.disabled = bBorrar.disabled = false; w.alert('Sin conexión'); });
    }
    bGuardar.addEventListener('click', function () { guardarPlantilla(false); });
    bNueva.addEventListener('click', function () { guardarPlantilla(true); });
    bBorrar.addEventListener('click', function () {
      var p = st.lista.filter(function (q) { return q.id === st.sel; })[0];
      if (!p || !w.confirm('¿Borrar la plantilla «' + p.nombre + '» para todo el equipo?')) return;
      bBorrar.disabled = true;
      api({ accion: 'correo-plantilla-borrar', id: p.id }).then(function (r) {
        bBorrar.disabled = false;
        if (abierto !== st) return;
        if (!r.ok) { w.alert('No se borró: ' + (r.error || '?')); return; }
        st.lista = r.plantillas || [];
        st.sel = '';
        cache.d = null;
        pintarSelect();
        selP.value = '__blanco';
        pintarGestion();
      }).catch(function () { bBorrar.disabled = false; w.alert('Sin conexión'); });
    });

    /* ---------- enviar ---------- */
    bSi.addEventListener('click', function () {
      if (st.enviado || !st.ultimo) return;
      var pl = plantillaActual();
      if (RE_RELLENAR.test(pl.cuerpo)) {
        w.alert('El texto todavía dice "' + (pl.cuerpo.match(RE_RELLENAR) || [''])[0] + '". Escribe ahí la información real antes de enviar.');
        inCu.focus();
        return;
      }
      var para = (st.ultimo.cliente && st.ultimo.cliente.email) || ref.email || '';
      if (!w.confirm('¿Enviar este correo a ' + para + '?\n\nAsunto: ' + st.ultimo.asunto)) return;
      var cuerpo = { accion: 'correo-enviar', plantilla: pl, pedido: inPed.value.trim().toUpperCase() };
      if (ref.id) cuerpo.id = ref.id; else if (ref.email) cuerpo.email = ref.email;
      st.ocupado = true;
      bSi.disabled = true; bNo.disabled = true;
      bSi.textContent = 'Enviando…';
      api(cuerpo).then(function (r) {
        st.ocupado = false;
        bNo.disabled = false;
        if (abierto !== st) return;
        if (sesionVencida(r)) { bSi.textContent = '📧 Enviar correo'; aviso('err', 'Tu sesión de la bandeja venció: recarga la página e ingresa de nuevo.'); return; }
        if (!r.ok) {
          bSi.textContent = '📧 Enviar correo';
          bSi.disabled = r.__status === 429;
          if (r.cupo) pintarCupo(r.cupo);
          aviso('err', '⚠️ ' + (r.error || 'No se pudo enviar'));
          return;
        }
        st.enviado = true;
        pintarCupo(r.cupo);
        bSi.textContent = '✅ Enviado';
        bNo.textContent = 'Cerrar';
        [selP, inAs, inTi, inCu, inBt, inBu, inPed].forEach(function (i) { i.disabled = true; });
        gest.hidden = true;
        vaciar(avisos);
        aviso('ok', ['✅ Correo enviado a ', el('b', { texto: r.para }), '. Quedó anotado en las notas de la ficha.']);
        notaEnFicha(ref.id, '📧 Correo enviado: «' + r.asunto + '»');
        bNo.focus();
      }).catch(function () {
        st.ocupado = false;
        bNo.disabled = false;
        bSi.textContent = '📧 Enviar correo';
        bSi.disabled = false;
        if (abierto !== st) return;
        aviso('err', '⚠️ Sin conexión: no sé si salió. Revisa las notas de la ficha antes de volver a enviarlo.');
      });
    });

    /* ---------- arranque ---------- */
    cargarPlantillas(false).then(function (r) {
      if (abierto !== st) return;
      if (sesionVencida(r)) { vaciar(selP); selP.appendChild(el('option', { value: '', texto: '—' })); aviso('err', 'Tu sesión de la bandeja venció: recarga la página e ingresa de nuevo.'); return; }
      if (!r.ok) { aviso('err', '⚠️ ' + (r.error || 'No se pudieron cargar las plantillas')); st.lista = []; pintarSelect(); return; }
      st.lista = r.plantillas || [];
      st.editar = !!r.puede_editar;
      st.variables = r.variables || [];
      pintarCupo(r.cupo);
      st.variables.forEach(function (v) {
        vars.appendChild(el('button', { type: 'button', clase: 'jcm-var', title: v.nombre, texto: '{' + v.k + '}', onclick: function () { insertar(v.k); } }));
      });
      pintarSelect();
      pintarGestion();
    }).catch(function () {
      if (abierto !== st) return;
      aviso('err', '⚠️ Sin conexión. Revisa el internet y vuelve a intentar.');
    });
  }

  /* después de enviar: la nota aparece en la ficha abierta, sin recargar */
  function notaEnFicha(id, texto) {
    var fi = d.querySelector('aside.bwa-fi');
    if (!fi || !id || !d.getElementById('bwa-fi-nota-' + id)) return;
    var lista = fi.querySelector('.bwa-fi-notas');
    if (!lista) return;
    var vacio = lista.querySelector('.bwa-fi-vacio');
    if (vacio) lista.removeChild(vacio);
    lista.insertBefore(el('div', { clase: 'bwa-fi-nota' }, [el('small', { texto: 'Tú · ahora' }), texto]), lista.firstChild);
  }

  /* ---------- leer la ficha abierta ---------- */
  function leerFicha(fi) {
    var ta = fi.querySelector('textarea[id^="bwa-fi-nota-"]');
    var datos = {};
    Array.prototype.forEach.call(fi.querySelectorAll('dl.bwa-fi-datos > div'), function (x) {
      var dt = x.querySelector('dt'), dd = x.querySelector('dd');
      if (dt && dd) datos[String(dt.textContent || '').trim()] = String(dd.textContent || '').trim();
    });
    var h2 = fi.querySelector('.bwa-fi-cab h2');
    var pedidos = [];
    Array.prototype.forEach.call(fi.querySelectorAll('.bwa-fi-ped b'), function (b) {
      var t = String(b.textContent || '').trim().toUpperCase();
      if (RE_PEDIDO.test(t) && pedidos.indexOf(t) === -1) pedidos.push(t);
    });
    var email = datos.Email || '';
    return {
      id: ta ? ta.id.slice('bwa-fi-nota-'.length) : '',
      nombre: h2 ? String(h2.textContent || '').trim() : '',
      email: RE_EMAIL.test(email) ? email.toLowerCase() : '',
      pedidos: pedidos
    };
  }

  /* ---------- botones ---------- */
  var pendiente = 0;  /* el botón del chat abrió la ficha: al cargar, abrir el correo */

  function montarFicha() {
    var fi = d.querySelector('aside.bwa-fi');
    if (!fi) { if (pendiente && Date.now() - pendiente > 3000) pendiente = 0; return; }
    var cab = fi.querySelector('.bwa-fi-cab');
    if (!cab) {
      /* la ficha terminó sin cliente (no está en el CRM o dio error) */
      if (pendiente && !/Cargando/.test(fi.textContent || '')) pendiente = 0;
      return;
    }
    if (cab.getAttribute('data-jcm')) return;
    cab.setAttribute('data-jcm', '1');
    var info = leerFicha(fi);
    var auto = pendiente && Date.now() - pendiente < 20000;
    pendiente = 0;
    if (!info.email) {
      if (auto) w.alert('Este cliente no tiene email guardado en el CRM, así que no se le puede enviar correo.');
      return;
    }
    var b = el('button', { type: 'button', id: 'jcm-fi-btn', clase: 'bwa-cli-btn bwa-cli-btn-sec', title: 'Enviarle un correo con una plantilla', texto: '📧 Enviar correo',
      onclick: function () { abrir(leerFicha(fi)); } });
    var acc = fi.querySelector('.bwa-fi-acc');
    if (!acc) {
      acc = el('div', { clase: 'bwa-fi-acc' });
      var kpis = fi.querySelector('.bwa-fi-kpis');
      var antes = kpis || cab;
      if (antes.nextSibling) antes.parentNode.insertBefore(acc, antes.nextSibling); else antes.parentNode.appendChild(acc);
    }
    acc.appendChild(b);
    if (auto) abrir(info);
  }

  function montarChat() {
    var panel = d.getElementById('bwa-acciones-panel');
    var ficha = d.getElementById('bwa-ficha');
    if (!panel || !ficha) return;
    var b = d.getElementById('jcm-crm-btn');
    if (!b) {
      b = el('button', { type: 'button', id: 'jcm-crm-btn', clase: 'bwa-accion-fila', texto: '📧 Enviar correo' });
      var ref = d.getElementById('jcc-crm-btn') || ficha;
      if (ref.nextSibling) panel.insertBefore(b, ref.nextSibling); else panel.appendChild(b);
      b.addEventListener('click', function () {
        var fondoP = d.getElementById('bwa-acciones-fondo');
        panel.classList.remove('bwa-on'); if (fondoP) fondoP.classList.remove('bwa-on');
        pendiente = Date.now();
        ficha.click();
      });
      if (w.MutationObserver) new MutationObserver(function () { b.style.display = ficha.style.display; }).observe(ficha, { attributes: true, attributeFilter: ['style'] });
    }
    b.style.display = ficha.style.display;
  }

  function iniciar() {
    montarChat();
    montarFicha();
    if (!w.MutationObserver) return;
    var prog = false;
    new MutationObserver(function () {
      if (prog) return;
      prog = true;
      (w.requestAnimationFrame || setTimeout)(function () { prog = false; montarFicha(); if (!d.getElementById('jcm-crm-btn')) montarChat(); });
    }).observe(d.body, { childList: true, subtree: true });
  }

  w.JBXCrmCorreo = { abrir: abrir, cerrar: cerrar, _leerFicha: leerFicha };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})(window, document);